import { spacing, media } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "../../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "../../node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const classNamePrefix = "umd-layout-grid-inline";
const columns = {
  alignItems: "flex-start",
  display: "flex",
  flexDirection: "column",
  gap: spacing.sm,
  justifyContent: "flex-start"
};
const row = {
  className: `${classNamePrefix}-rows`,
  display: "flex",
  gap: spacing.min,
  alignItems: "center"
};
const tabletRows = objectWithClassName({
  ...columns,
  [`@media (${media.queries.large.min})`]: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center"
  },
  className: [
    `${classNamePrefix}-tablet-rows`,
    /** @deprecated Use 'umd-layout-grid-inline-tablet-rows' instead */
    "umd-grid-row-mobile-tablet"
  ]
});
const stretch = objectWithClassName({
  display: "flex",
  flexWrap: "wrap",
  gap: spacing.sm,
  justifyContent: "space-between",
  position: "relative",
  "& > *:first-child": {
    maxWidth: "100%",
    flex: "1 0 auto"
  },
  "& > *:first-child + *:last-child:not(:first-child)": {
    margin: 0,
    position: "relative",
    zIndex: 999
  },
  className: [
    `${classNamePrefix}-stretch`,
    /** @deprecated Use 'umd-layout-grid-inline-stretch' instead */
    "umd-forms-layout-headline-with-action"
  ]
});
export {
  row,
  stretch,
  tabletRows
};
//# sourceMappingURL=inline.js.map
